<template>
  <div class="spinner" :class="[color, size]" role="status" :aria-label="$t('vue2.a11y.loading')">
    <div class="bounce1" aria-hidden="true"></div>
    <div class="bounce2" aria-hidden="true"></div>
    <div class="bounce3" aria-hidden="true"></div>
  </div>
</template>

<script>
  export default {
    name: 'spinner',
    props: {
      color: {
        type: String,
        default: 'white'
      },
      size: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .spinner {
    margin: 100px auto 0;
    width: 70px;
    text-align: center;
  }

  .spinner > div {
    width: 18px;
    height: 18px;
    background-color: white;

    border-radius: 100%;
    display: inline-block;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .spinner.small > div {
    width: 12px;
    height: 12px;
  }

  .spinner.blue > div {
    background-color: var(--blue);
  }

  .spinner .bounce1 {
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    animation-delay: -0.16s;
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      transform: scale(0);
    } 40% {
        transform: scale(1.0);
      }
  }
</style>



// WEBPACK FOOTER //
// Spinner.vue?56d12fe4